import { useContext } from "@/store/context";
export const useUserTranslation = () => {
    /**
     * Find the locale that would be used by $u. In general, prefer using $u.
     *
     * @param valueMap The textmap (object keyed by locale)
     */
    const contextStore = useContext();
    const firstPreferredLocale = (valueMap) => {
        if (!valueMap) {
            return undefined;
        }
        const textMap = (valueMap.textMap || valueMap);
        for (let i = 0; i < contextStore.preferredLocales.length; i++) {
            if (textMap[contextStore.preferredLocales[i]]) {
                return contextStore.preferredLocales[i];
            }
        }
        return undefined;
    };
    /**
     * Translate a multilingual user string based on the prefered locales. This is similar to $t of i18n but
     * this is a `u` for "user".
     *
     * @param valueMap The textmap (object keyed by locale)
     */
    const $u = (valueMap) => {
        if (!valueMap) {
            return "";
        }
        const textMap = (valueMap.textMap || valueMap);
        const locale = firstPreferredLocale(textMap);
        return locale ? textMap[locale] : "";
    };
    /**
     * Translate a multilingual user string (textmap) to the first of the preferred
     * languages available.
     *
     * @param valueMap The textmap (object keyed by locale)
     * @param locale The preferred language for translation. If a list, fallback occurs to subesequent locales
     */
    const translateToLocale = (valueMap, locale) => {
        if (!valueMap) {
            return "";
        }
        const textMap = (valueMap.textMap || valueMap);
        const localeList = Array.isArray(locale)
            ? locale
            : [locale || ""];
        for (let i = 0; i < localeList.length; i++) {
            const locale = localeList[i];
            if (!locale)
                continue;
            if (textMap[locale])
                return textMap[locale];
        }
        return "";
    };
    return { $u, firstPreferredLocale, translateToLocale };
};
